// import { useParams } from "react-router-dom";
// import { useEffect, useState } from "react";
// import axios from "axios";
// import "./TrackOrder.scss";
// import HeaderOne from "../../../HeaderOne";
// import Breadcrumb from "../../../Breadcrumb";
// import FooterOne from "../../../FooterOne";

// const STATUS_STEPS = [
//   {
//     key: "order_placed",
//     label: "Order Placed",
//     icon: "📋",
//     description: "Your order has been confirmed.",
//   },
//   {
//     key: "shipment_created",
//     label: "Shipment Created",
//     icon: "📦",
//     description: "Shipment handed off to courier.",
//   },
//   {
//     key: "pickup_scheduled",
//     label: "Pickup Scheduled",
//     icon: "🚚",
//     description: "Courier pickup has been arranged.",
//   },
//   {
//     key: "in_transit",
//     label: "In Transit",
//     icon: "🛣️",
//     description: "Your package is on its way.",
//   },
//   {
//     key: "out_for_delivery",
//     label: "Out For Delivery",
//     icon: "🏠",
//     description: "Delivery partner is heading to you.",
//   },
//   {
//     key: "delivered",
//     label: "Delivered",
//     icon: "✅",
//     description: "Package delivered successfully.",
//   },
// ];

// const resolveSteps = (orderData) => {
//   const status = orderData?.shiprocket?.current_status || "NEW";

//   return STATUS_STEPS.map((step) => {
//     let completed = false;
//     switch (step.key) {
//       case "order_placed":
//         completed = true;
//         break;
//       case "shipment_created":
//         completed = !!orderData?.shiprocket?.isCreated;
//         break;
//       case "pickup_scheduled":
//         completed = !!orderData?.shiprocket?.pickup_scheduled;
//         break;
//       case "in_transit":
//         completed = ["In Transit", "Out For Delivery", "Delivered"].includes(status);
//         break;
//       case "out_for_delivery":
//         completed = ["Out For Delivery", "Delivered"].includes(status);
//         break;
//       case "delivered":
//         completed = status === "Delivered";
//         break;
//       default:
//         break;
//     }
//     return { ...step, completed };
//   });
// };

// const formatDate = (dateStr) => {
//   if (!dateStr) return "";
//   const d = new Date(dateStr);
//   return d.toLocaleString("en-IN", {
//     day: "2-digit",
//     month: "short",
//     year: "numeric",
//     hour: "2-digit",
//     minute: "2-digit",
//     hour12: true,
//   });
// };

// const TrackOrder = () => {
//   const { orderId } = useParams();
//   const [order, setOrder] = useState(null);
//   const [steps, setSteps] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showFullHistory, setShowFullHistory] = useState(false);

//   const getTracking = async () => {
//     try {
//       const res = await axios.get(
//         `${process.env.REACT_APP_API_URL}/order/track-order/${orderId}`
//       );
//       const orderData = res.data.order;
//       setOrder(orderData);
//       setSteps(resolveSteps(orderData));
//     } catch (error) {
//       console.error(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     getTracking();
//   }, [orderId]);

//   if (loading) {
//     return (
//       <>
//         <HeaderOne />
//         <Breadcrumb />
//         <div className="to-wrapper">
//           <div className="to-skeleton">
//             <div className="skel skel--title" />
//             <div className="skel skel--line" />
//             <div className="skel skel--line short" />
//             <div className="skel skel--block" />
//           </div>
//         </div>
//         <FooterOne />
//       </>
//     );
//   }

//   if (!order) {
//     return (
//       <>
//         <HeaderOne />
//         <Breadcrumb />
//         <div className="to-wrapper">
//           <div className="to-empty">
//             <span className="to-empty__icon">🔍</span>
//             <h3>Order not found</h3>
//             <p>We couldn't find details for order #{orderId}.</p>
//           </div>
//         </div>
//         <FooterOne />
//       </>
//     );
//   }

//   const shiprocket = order.shiprocket || {};
//   const tracking = shiprocket.trackingHistory || [];
//   const currentStatus = shiprocket.current_status || "Processing";
//   const isDelivered = currentStatus === "Delivered";
//   const activeStepIndex = [...steps].reverse().findIndex((s) => s.completed);
//   const activeStep =
//     activeStepIndex >= 0 ? steps[steps.length - 1 - activeStepIndex] : steps[0];
//   const visibleHistory = showFullHistory ? tracking : tracking.slice(0, 3);

//   return (
//     <>
//       <HeaderOne />
//       <Breadcrumb />

//       <div className="to-wrapper">
//         {/* ── Page Header ── */}
//         <div className="to-page-header">
//           <div>
//             <h1 className="to-page-title">Track Your Order</h1>
//             <p className="to-page-subtitle">
//               Order ID: <span>{order._id}</span>
//             </p>
//           </div>
//           <div className={`to-status-badge ${isDelivered ? "delivered" : "transit"}`}>
//             {currentStatus}
//           </div>
//         </div>

//         <div className="to-grid">
//           {/* ── Left Column ── */}
//           <div className="to-col-main">

//             {/* ── Progress Bar ── */}
//             <div className="to-card">
//               <div className="to-card__head">
//                 <h2>Delivery Progress</h2>
//                 {shiprocket.awb_code && (
//                   <p className="to-card__meta">
//                     AWB: <strong>{shiprocket.awb_code}</strong>
//                   </p>
//                 )}
//               </div>

//               <div className="to-progress">
//                 {steps.map((step, i) => {
//                   const isActive = step.key === activeStep?.key;
//                   const isPast = step.completed && !isActive;

//                   return (
//                     <div
//                       key={step.key}
//                       className={`to-progress__step ${step.completed ? "done" : ""} ${isActive ? "active" : ""}`}
//                     >
//                       {/* connector line */}
//                       {i < steps.length - 1 && (
//                         <div
//                           className={`to-progress__line ${steps[i + 1]?.completed ? "filled" : ""}`}
//                         />
//                       )}

//                       <div className="to-progress__dot">
//                         {step.completed ? (
//                           <svg viewBox="0 0 20 20" fill="currentColor">
//                             <path
//                               fillRule="evenodd"
//                               d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
//                               clipRule="evenodd"
//                             />
//                           </svg>
//                         ) : (
//                           <span className="to-progress__index">{i + 1}</span>
//                         )}
//                       </div>

//                       <div className="to-progress__label">
//                         <span className="to-progress__name">{step.label}</span>
//                         {isActive && (
//                           <span className="to-progress__desc">{step.description}</span>
//                         )}
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>

//             {/* ── Tracking History ── */}
//             {tracking.length > 0 && (
//               <div className="to-card">
//                 <div className="to-card__head">
//                   <h2>Shipment History</h2>
//                 </div>

//                 <div className="to-history">
//                   {visibleHistory.map((event, i) => (
//                     <div key={event._id || i} className={`to-history__row ${i === 0 ? "latest" : ""}`}>
//                       <div className="to-history__dot" />
//                       <div className="to-history__body">
//                         <p className="to-history__activity">{event.activity}</p>
//                         <p className="to-history__meta">
//                           <span className="to-history__loc"> {event.location}</span>
//                           <span className="to-history__date">{formatDate(event.date)}</span>
//                         </p>
//                       </div>
//                     </div>
//                   ))}
//                 </div>

//                 {tracking.length > 3 && (
//                   <button
//                     className="to-toggle-btn"
//                     onClick={() => setShowFullHistory(!showFullHistory)}
//                   >
//                     {showFullHistory
//                       ? "Show less ▲"
//                       : `View all ${tracking.length} events ▼`}
//                   </button>
//                 )}
//               </div>
//             )}
//           </div>

//           {/* ── Right Column ── */}
//           <div className="to-col-side">

//             {/* ── Order Items ── */}
//             <div className="to-card">
//               <div className="to-card__head">
//                 <h2>Items in This Order</h2>
//               </div>

//               {order.items?.map((item) => (
//                 <div key={item._id} className="to-item">
//                   {item.images?.[0] && (
//                     <img
//                       src={item.images[0]}
//                       alt={item.name}
//                       className="to-item__img"
//                     />
//                   )}
//                   <div className="to-item__info">
//                     <p className="to-item__name">{item.name}</p>
//                     {item.color && (
//                       <p className="to-item__meta">
//                         <span
//                           className="to-item__swatch"
//                           style={{ background: item.color.toLowerCase() }}
//                         />
//                         {item.color}
//                       </p>
//                     )}
//                     {item.size && (
//                       <p className="to-item__meta">Size: {item.size}</p>
//                     )}
//                     <p className="to-item__meta">Qty: {item.qty}</p>
//                     <p className="to-item__price">
//                       {item.currency} {item.price.toLocaleString("en-IN")}
//                     </p>
//                   </div>
//                 </div>
//               ))}

//               <div className="to-order-total">
//                 <div className="to-order-total__row">
//                   <span>Subtotal</span>
//                   <span>₹{order.subtotal?.toLocaleString("en-IN")}</span>
//                 </div>
//                 <div className="to-order-total__row">
//                   <span>Delivery</span>
//                   <span>{order.delivery === 0 ? "FREE" : `₹${order.delivery}`}</span>
//                 </div>
//                 <div className="to-order-total__row">
//                   <span>Tax</span>
//                   <span>₹{order.tax}</span>
//                 </div>
//                 <div className="to-order-total__row total">
//                   <span>Total</span>
//                   <span>₹{order.totalAmount?.toLocaleString("en-IN")}</span>
//                 </div>
//                 <div className="to-payment-badge">
//                   {order.paymentMethod?.toUpperCase()} ·{" "}
//                   <span className={order.paymentStatus === "SUCCESS" ? "paid" : "pending"}>
//                     {order.paymentStatus}
//                   </span>
//                 </div>
//               </div>
//             </div>

//             {/* ── Shipping Address ── */}
//             <div className="to-card">
//               <div className="to-card__head">
//                 <h2>Delivery Address</h2>
//               </div>
//               <div className="to-address">
//                 <p className="to-address__name">
//                   {order.shipping?.firstName} {order.shipping?.lastName}
//                 </p>
//                 <p>{order.shipping?.address1}</p>
//                 <p>
//                   {order.shipping?.city}, {order.shipping?.state} –{" "}
//                   {order.shipping?.pincode}
//                 </p>
//                 <p>{order.shipping?.country}</p>
//                 <p className="to-address__contact">
//                   📞 {order.shipping?.phone}
//                 </p>
//                 <p className="to-address__contact">
//                   ✉️ {order.shipping?.email}
//                 </p>
//               </div>
//             </div>

//             {/* ── Courier Info ── */}
//             {shiprocket.isCreated && (
//               <div className="to-card to-card--courier">
//                 <div className="to-courier">
//                   <div className="to-courier__icon">🚚</div>
//                   <div>
//                     <p className="to-courier__name">
//                       {shiprocket.courier_name || "Courier Partner"}
//                     </p>
//                     <p className="to-courier__awb">
//                       AWB: {shiprocket.awb_code}
//                     </p>
//                     <p className="to-courier__id">
//                       Shipment ID: {shiprocket.shipment_id}
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       <FooterOne />
//     </>
//   );
// };

// export default TrackOrder;

import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import "./TrackOrder.scss";
import HeaderOne from "../../../HeaderOne";
import Breadcrumb from "../../../Breadcrumb";
import FooterOne from "../../../FooterOne";

const STATUS_STEPS = [
  {
    key: "order_placed",
    label: "Order Placed",
    icon: "📋",
    description: "Your order has been confirmed.",
  },
  {
    key: "shipment_created",
    label: "Shipment Created",
    icon: "📦",
    description: "Shipment handed off to courier.",
  },
  {
    key: "pickup_scheduled",
    label: "Pickup Scheduled",
    icon: "🚚",
    description: "Courier pickup has been arranged.",
  },
  {
    key: "in_transit",
    label: "In Transit",
    icon: "🛣️",
    description: "Your package is on its way.",
  },
  {
    key: "out_for_delivery",
    label: "Out For Delivery",
    icon: "🏠",
    description: "Delivery partner is heading to you.",
  },
  {
    key: "delivered",
    label: "Delivered",
    icon: "✅",
    description: "Package delivered successfully.",
  },
];

// ── Shiprocket raw status → display label ──────────────────────────────────
// Shiprocket's current_status can be raw strings like "REACHED AT DESTINATION HUB",
// "OUT FOR DELIVERY", "DELIVERED", etc. Map them to clean display labels.
const SHIPROCKET_STATUS_MAP = {
  // New / pending
  NEW:                          { label: "Order Placed",              level: 0 },
  "X-UCI":                      { label: "Manifested",                level: 1 },

  // Pickup
  "PICKUP PENDING":             { label: "Pickup Pending",            level: 2 },
  "PICKUP GENERATED":           { label: "Pickup Scheduled",          level: 2 },
  "PICKUP QUEUED":              { label: "Pickup Queued",             level: 2 },
  "PICKUP RESCHEDULED":         { label: "Pickup Rescheduled",        level: 2 },
  "PICKED UP":                  { label: "Picked Up",                 level: 3 },

  // In transit
  "IN TRANSIT":                 { label: "In Transit",                level: 4 },
  "REACHED AT DESTINATION HUB": { label: "Reached Destination Hub",  level: 4 },
  "REACHED AT TRANSHIPMENT HUB":{ label: "In Transit",               level: 4 },
  "MISROUTED":                  { label: "In Transit (Misrouted)",    level: 4 },

  // Out for delivery
  "OUT FOR DELIVERY":           { label: "Out For Delivery",          level: 5 },

  // Delivered
  "DELIVERED":                  { label: "Delivered",                 level: 6 },
  Delivered:                    { label: "Delivered",                 level: 6 },

  // RTO / failed
  "RTO INITIATED":              { label: "Return Initiated",          level: -1 },
  "RTO IN TRANSIT":             { label: "Return In Transit",         level: -1 },
  "RTO DELIVERED":              { label: "Returned to Seller",        level: -1 },
  "LOST":                       { label: "Lost",                      level: -1 },
  "DAMAGED":                    { label: "Damaged",                   level: -1 },
};

// Normalise any raw status to a friendly display label
const normalizeStatusLabel = (raw = "") => {
  const entry = SHIPROCKET_STATUS_MAP[raw] || SHIPROCKET_STATUS_MAP[raw.toUpperCase()];
  return entry ? entry.label : raw;
};

// Returns the numeric "level" for a raw status (used to mark steps complete)
const statusLevel = (raw = "") => {
  const key = Object.keys(SHIPROCKET_STATUS_MAP).find(
    (k) => k.toUpperCase() === raw.toUpperCase()
  );
  return key ? SHIPROCKET_STATUS_MAP[key].level : 0;
};

const resolveSteps = (orderData) => {
  const rawStatus = orderData?.shiprocket?.current_status || "NEW";
  const level = statusLevel(rawStatus);

  return STATUS_STEPS.map((step) => {
    let completed = false;
    switch (step.key) {
      case "order_placed":
        completed = true;
        break;
      case "shipment_created":
        completed = !!orderData?.shiprocket?.isCreated;
        break;
      case "pickup_scheduled":
        // level >= 2 means pickup at minimum scheduled; also honour the flag
        completed = !!orderData?.shiprocket?.pickup_scheduled || level >= 2;
        break;
      case "in_transit":
        completed = level >= 4;
        break;
      case "out_for_delivery":
        completed = level >= 5;
        break;
      case "delivered":
        completed = level >= 6;
        break;
      default:
        break;
    }
    return { ...step, completed };
  });
};

const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  return d.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

const TrackOrder = () => {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);
  const [steps, setSteps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showFullHistory, setShowFullHistory] = useState(false);

  const getTracking = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/order/track-order/${orderId}`
      );
      const orderData = res.data.order;
      setOrder(orderData);
      setSteps(resolveSteps(orderData));
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTracking();
  }, [orderId]);

  if (loading) {
    return (
      <>
        <HeaderOne />
        <Breadcrumb />
        <div className="to-wrapper">
          <div className="to-skeleton">
            <div className="skel skel--title" />
            <div className="skel skel--line" />
            <div className="skel skel--line short" />
            <div className="skel skel--block" />
          </div>
        </div>
        <FooterOne />
      </>
    );
  }

  if (!order) {
    return (
      <>
        <HeaderOne />
        <Breadcrumb />
        <div className="to-wrapper">
          <div className="to-empty">
            <span className="to-empty__icon">🔍</span>
            <h3>Order not found</h3>
            <p>We couldn't find details for order #{orderId}.</p>
          </div>
        </div>
        <FooterOne />
      </>
    );
  }

  const shiprocket = order.shiprocket || {};
  const tracking = shiprocket.trackingHistory || [];
  const rawStatus = shiprocket.current_status || "";
  const currentStatus = normalizeStatusLabel(rawStatus) || "Processing";
  const isDelivered = statusLevel(rawStatus) >= 6;
  const isRTO = statusLevel(rawStatus) === -1;
  const activeStepIndex = [...steps].reverse().findIndex((s) => s.completed);
  const activeStep =
    activeStepIndex >= 0 ? steps[steps.length - 1 - activeStepIndex] : steps[0];
  const visibleHistory = showFullHistory ? tracking : tracking.slice(0, 3);

  return (
    <>
      <HeaderOne />
      <Breadcrumb />

      <div className="to-wrapper">
        {/* ── Page Header ── */}
        <div className="to-page-header">
          <div>
            <h1 className="to-page-title">Track Your Order</h1>
            <p className="to-page-subtitle">
              Order ID: <span>{order._id}</span>
            </p>
          </div>
          <div
            className={`to-status-badge ${
              isDelivered ? "delivered" : isRTO ? "rto" : "transit"
            }`}
          >
            {currentStatus}
          </div>
        </div>

        <div className="to-grid">
          {/* ── Left Column ── */}
          <div className="to-col-main">

            {/* ── Progress Bar ── */}
            <div className="to-card">
              <div className="to-card__head">
                <h2>Delivery Progress</h2>
                {shiprocket.awb_code && (
                  <p className="to-card__meta">
                    AWB: <strong>{shiprocket.awb_code}</strong>
                  </p>
                )}
              </div>

              <div className="to-progress">
                {steps.map((step, i) => {
                  const isActive = step.key === activeStep?.key;
                  const isPast = step.completed && !isActive;

                  return (
                    <div
                      key={step.key}
                      className={`to-progress__step ${step.completed ? "done" : ""} ${isActive ? "active" : ""}`}
                    >
                      {/* connector line */}
                      {i < steps.length - 1 && (
                        <div
                          className={`to-progress__line ${steps[i + 1]?.completed ? "filled" : ""}`}
                        />
                      )}

                      <div className="to-progress__dot">
                        {step.completed ? (
                          <svg viewBox="0 0 20 20" fill="currentColor">
                            <path
                              fillRule="evenodd"
                              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                              clipRule="evenodd"
                            />
                          </svg>
                        ) : (
                          <span className="to-progress__index">{i + 1}</span>
                        )}
                      </div>

                      <div className="to-progress__label">
                        <span className="to-progress__name">{step.label}</span>
                        {isActive && (
                          <span className="to-progress__desc">{step.description}</span>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* ── Tracking History ── */}
            {tracking.length > 0 && (
              <div className="to-card">
                <div className="to-card__head">
                  <h2>Shipment History</h2>
                </div>

                <div className="to-history">
                  {visibleHistory.map((event, i) => (
                    <div key={event._id || i} className={`to-history__row ${i === 0 ? "latest" : ""}`}>
                      <div className="to-history__dot" />
                      <div className="to-history__body">
                        <div className="to-history__top">
                          <p className="to-history__activity">{event.activity}</p>
                          {event.srStatusLabel && event.srStatusLabel !== "NA" && (
                            <span className="to-history__tag">{event.srStatusLabel}</span>
                          )}
                        </div>
                        <p className="to-history__meta">
                          <span className="to-history__loc">📍 {event.location}</span>
                          <span className="to-history__date">{formatDate(event.date)}</span>
                        </p>
                      </div>
                    </div>
                  ))}
                </div>

                {tracking.length > 3 && (
                  <button
                    className="to-toggle-btn"
                    onClick={() => setShowFullHistory(!showFullHistory)}
                  >
                    {showFullHistory
                      ? "Show less ▲"
                      : `View all ${tracking.length} events ▼`}
                  </button>
                )}
              </div>
            )}
          </div>

          {/* ── Right Column ── */}
          <div className="to-col-side">

            {/* ── Order Items ── */}
            <div className="to-card">
              <div className="to-card__head">
                <h2>Items in This Order</h2>
              </div>

              {order.items?.map((item) => (
                <div key={item._id} className="to-item">
                  {item.images?.[0] && (
                    <img
                      src={item.images[0]}
                      alt={item.name}
                      className="to-item__img"
                    />
                  )}
                  <div className="to-item__info">
                    <p className="to-item__name">{item.name}</p>
                    {item.color && (
                      <p className="to-item__meta">
                        <span
                          className="to-item__swatch"
                          style={{ background: item.color.toLowerCase() }}
                        />
                        {item.color}
                      </p>
                    )}
                    {item.size && (
                      <p className="to-item__meta">Size: {item.size}</p>
                    )}
                    <p className="to-item__meta">Qty: {item.qty}</p>
                    <p className="to-item__price">
                      {item.currency} {item.price.toLocaleString("en-IN")}
                    </p>
                  </div>
                </div>
              ))}

              <div className="to-order-total">
                <div className="to-order-total__row">
                  <span>Subtotal</span>
                  <span>₹{order.subtotal?.toLocaleString("en-IN")}</span>
                </div>
                <div className="to-order-total__row">
                  <span>Delivery</span>
                  <span>{order.delivery === 0 ? "FREE" : `₹${order.delivery}`}</span>
                </div>
                <div className="to-order-total__row">
                  <span>Tax</span>
                  <span>₹{order.tax}</span>
                </div>
                <div className="to-order-total__row total">
                  <span>Total</span>
                  <span>₹{order.totalAmount?.toLocaleString("en-IN")}</span>
                </div>
                <div className="to-payment-badge">
                  {order.paymentMethod?.toUpperCase()} ·{" "}
                  <span className={order.paymentStatus === "SUCCESS" ? "paid" : "pending"}>
                    {order.paymentStatus}
                  </span>
                </div>
              </div>
            </div>

            {/* ── Shipping Address ── */}
            <div className="to-card">
              <div className="to-card__head">
                <h2>Delivery Address</h2>
              </div>
              <div className="to-address">
                <p className="to-address__name">
                  {order.shipping?.firstName} {order.shipping?.lastName}
                </p>
                <p>{order.shipping?.address1}</p>
                <p>
                  {order.shipping?.city}, {order.shipping?.state} –{" "}
                  {order.shipping?.pincode}
                </p>
                <p>{order.shipping?.country}</p>
                <p className="to-address__contact">
                  📞 {order.shipping?.phone}
                </p>
                <p className="to-address__contact">
                  ✉️ {order.shipping?.email}
                </p>
              </div>
            </div>

            {/* ── Courier Info ── */}
            {shiprocket.isCreated && (
              <div className="to-card to-card--courier">
                <div className="to-courier">
                  <div className="to-courier__icon">🚚</div>
                  <div>
                    <p className="to-courier__name">
                      {shiprocket.courier_name || "Courier Partner"}
                    </p>
                    <p className="to-courier__awb">
                      AWB: {shiprocket.awb_code}
                    </p>
                    <p className="to-courier__id">
                      Shipment ID: {shiprocket.shipment_id}
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <FooterOne />
    </>
  );
};

export default TrackOrder;